/**
 * title Show/Hide Content
 * description This determines which tabs to show and which to hide based on the navigation
 * param {string} tabContainer
 */
function showHideContent(tabContainer) {
    const tabContainerName = tabContainer.dataset.tabNavigation;
    const activeTab = tabContainer.querySelector('.active-tab');
    const activeTabName = activeTab.dataset.tab;
    const activeContentContainer = document.querySelector('[data-tab-content="' + tabContainerName + '"]');
    const activeContentBlock = activeContentContainer.querySelectorAll('[data-content="' + activeTabName + '"]');
    
    for (let a = 0; a < activeContentBlock.length; a++) {
        const contentBlocks = activeContentBlock[a].parentElement.children;

        for (let i = 0; i < contentBlocks.length; i++) {
            if (contentBlocks[i] === activeContentBlock[a] && contentBlocks[i].hasAttribute('data-content')) {
                                
                contentBlocks[i].classList.add('d-block');
                contentBlocks[i].classList.remove('d-none');
            } else if (contentBlocks[i] !== activeContentBlock[a] && contentBlocks[i].hasAttribute('data-content')) {
                contentBlocks[i].classList.add('d-none');
                contentBlocks[i].classList.remove('d-block');
            }
        }
        
    }
}

/**
 * title Find the Active Content
 */
function findActiveContent() {
    const activeTabClass = 'active-tab';
    const tabContainers = document.querySelectorAll('[data-tab-navigation]');

    for (let i = 0; i < tabContainers.length; i++) {
        const activeTabs = tabContainers[i].querySelectorAll('.' + activeTabClass);

        if (!activeTabs.length) {
            tabContainers[i].querySelector('[data-tab]').classList.add(activeTabClass);
        }

        showHideContent(tabContainers[i]);
    }

    const firstActiveTab = document.querySelector('.active-tab');
}

function toggleActiveTab(tab) {
    const activeTabClass = 'active-tab';
    const navTabs = tab.parentElement.children;

    for (let i = 0; i < navTabs.length; i++) {
        if (navTabs[i] !== tab) {
            navTabs[i].classList.remove(activeTabClass);
        } else {
            navTabs[i].classList.add(activeTabClass);
        }
    }
}

function switchTab(tab) {
    toggleActiveTab(tab);
    findActiveContent();
}

function tabNavigation() {
    const dataTab = document.querySelector('.tab');
    if (document.body.contains(dataTab)) {    
        switchTab(dataTab);        
        document.querySelector('body').addEventListener('click', function(e) {
            if (e.target.hasAttribute('data-tab')) {
                switchTab(e.target);    
            }
        });
    }
};

export default tabNavigation;
